<template>
    <li
        @click="onClick"
        role="option"
        class="block px-4 py-2 whitespace-no-wrap cursor-pointer text-gray-1 hover:bg-beige"
    >
        <slot />
    </li>
</template>

<script>
export default {
    props: ["value", "selected"],

    methods: {
        onClick() {
            this.$emit("selected", this);
        }
    }
};
</script>
